import { PERSIST_TABLE_IDS } from 'types/enums';
import type { NavigationResult } from 'types';

export const createNavigationStateUpdate = (navigationResult: NavigationResult) => {
  return {
    key: `table-${PERSIST_TABLE_IDS.USER_AGENDA_TABLE}`,
    data: {
      lastClickedRow: navigationResult.navigationState,
    },
  };
};
